// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Thanks__background___1VIrO{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fcfcfc;width:100%;height:100%}.Thanks__background___1VIrO,.Thanks__base___SnPwl{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.Thanks__base___SnPwl{font-size:20px;line-height:36px;color:#4f4f4f;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-radius:6px;text-align:center;width:500px;padding:40px 40px;background:#fff;-webkit-box-shadow:0 0 93px rgba(0,0,0,.0651);box-shadow:0 0 93px rgba(0,0,0,.0651)}.Thanks__checkmark___27eNo{width:100px;padding:20px 10px 20px}", ""]);
// Exports
exports.locals = {
	"background": "Thanks__background___1VIrO",
	"base": "Thanks__base___SnPwl",
	"checkmark": "Thanks__checkmark___27eNo"
};
module.exports = exports;
